<script setup lang="ts">
const value = defineModel<string|null>();

const emit = defineEmits<{ click: [] }>()
</script>

<template>
    <v-text-field
        v-model="value"
        placeholder="Search"
        density="compact"
        rounded="e-0"
        hide-details
        autofocus
        @keydown.enter="emit('click')"
    >
        <template #append>
            <v-icon-btn
                icon="mdi-magnify"
                tile
                class="rounded custom-border rounded-s-0"
                color="white"
                @click="emit('click')"
            />
        </template>
    </v-text-field>
</template>

<style scoped>
:deep(.v-field__input) {
    border-right: 1px solid #8C8C8C;
}

:deep(.v-input__append) {
    margin-left: 0 !important;
}

.custom-border {
    border-bottom: 1px solid #8C8C8C;
    border-right: 1px solid #8C8C8C;
    border-top: 1px solid #8C8C8C;
}
</style>
